export const recordStatusCodes = [
  { code: 'All', label: 'All' },
  { code: 'ACTIVE', label: 'Active' },
  { code: 'DRAFT', label: 'Draft' },
  { code: 'PENDING_LEAD_APPROVAL', label: 'Pending lead approval' },
  { code: 'PENDING_REMOVAL', label: 'Pending removal' },
  { code: 'REMOVED', label: 'Removed' },
]

export type { RecordServiceStatus, ServiceCode, ServiceCollaboratorStatus } from '@rdm/db'
export const recordServiceStatusCodes = [
  { code: 'All', label: 'All' },
  { code: 'ACTIVE', label: 'Active' },
  { code: 'PENDING_CREATION', label: 'Pending creation' },
  { code: 'PENDING_SERVICE_RESPONSE', label: 'Pending service response' },
  { code: 'PENDING_RECORD_SUBMISSION', label: 'Pending service submission' },
  { code: 'PENDING_SERVICE_REMOVAL', label: 'Pending service removal' },
]

export const feedbackTypes = [
  { code: 'COMPLAINT', label: 'Complaint' },
  { code: 'COMPLIMENT', label: 'Compliment' },
  { code: 'FEATURE_IDEA', label: 'Feature idea' },
]

export const updateTypes = [
  { code: 'IMPROVEMENT', label: 'New feature' },
  { code: 'NEWSLETTER', label: 'Newsletter' },
  { code: 'RELEASE_NOTES', label: 'Technical release notes' },
  { code: 'HUMAN_ETHICS_PROJECT', label: 'Human ethics project' },
  { code: 'ANIMAL_ETHICS_PROJECT', label: 'Animal ethics project' },
  { code: 'ETHICS_PROJECT', label: 'General ethics' },
]

export const updateStatus = [
  { code: 'DRAFT', label: 'Draft' },
  { code: 'PUBLISHED', label: 'Published' },
]

export const ipOwners = [
  { code: 'uq-staff', name: 'UQ' },
  { code: 'rhd-signed', name: 'HDR - IP signed over to UQ' },
  { code: 'rhd-notsigned', name: 'HDR - IP not signed over to UQ' },
  { code: 'other-institution', name: 'Other academic institution' },
  { code: 'industry', name: 'Industry' },
  { code: 'joint-owners', name: 'Joint owners' },
  { code: 'other', name: 'Other' },
]

export const retentionPeriods = [
  {
    code: 'not-retained',
    name: 'Data will not be retained (legal, ethical or technical reasons)',
  },
  { code: '5-years', name: '5 years (standard retention period)' },
  {
    code: '7-years',
    name: '7 years after expiry of patent (if research data results in patent)',
  },
  { code: 'over-15-years', name: '>= 15 years (clinical trials)' },
  {
    code: 'indefinitely',
    name: 'Indefinitely (e.g. controversial, significant value to other researchers)',
  },
  { code: 'other', name: 'Other' },
]

export const humanInformationTypes = [
  { code: 'personal-information', name: 'Personal information' },
  { code: 'sensitive-information', name: 'Sensitive information' },
  { code: 'health-information', name: 'Health information' },
  { code: 'non-personal-information', name: 'Non-personal information' },
]

export const humanIdentifiabilityTypes = [
  { code: 'individually-identifiable-information', name: 'Individually identifiable information' },
  { code: 're-identifiable-information', name: 'Re-identifiable (coded) information' },
  { code: 'non-identifiable-information', name: 'Non-identifiable information' },
]

export const humanInformationSourceTypes = [
  { code: 'individual-participants', name: 'Individual participants' },
  { code: 'relatives', name: 'Relatives or associates of participants' },
  { code: 'health-records', name: 'Medical/health/mental health record' },
  { code: 'electoral-roll', name: 'Electoral roll' },
  { code: 'held-by-law-enforcement-agency', name: 'Held by a law enforcement agency' },
  { code: 'public-commonwealth-database', name: 'Publicly held database (commonwealth)' },
  { code: 'public-state-database', name: 'Publicly held database (state or local)' },
  { code: 'private-database', name: 'Privately held database' },
]

export const storageTypes = [
  {
    code: 'STANDARD',
    label:
      'This storage allocation will not be used to store identifiable human data, nor does it require HPC facilities',
  },

  { code: 'HUMAN_IDENTIFIABLE', label: 'This storage allocation will be used to store human identifiable data' },
  {
    code: 'HPC',
    label: 'The storage allocation will be used to store data that needs to be accessed by UQ HPC facilities',
  },
]
